import axiosInstance from "services/AxiosInstance";
import { TUserAccount } from "types";

export const removeUserRole = async ({ userId, accountId, ...params }: TUserAccount) => {
  const response = await axiosInstance.delete(`/accounts/${accountId}/users/${userId}`, { params });
  return response.data;
};
